import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ActiveButton, InactiveButton } from "./TabButton.styles";
import { RichTextStyle } from "../RichText";
import { InteractiveText } from "../../Text";
var TabButton = function(param) {
    var onSelectTab = param.behavior.onSelectTab, _content = param.content, name = _content.name, position = _content.position, tabGroup = _content.tabGroup, rules = param.rules;
    var ref = rules || {}, activeTabName = ref.activeTabName, _textStyle = ref.textStyle, textStyle = _textStyle === void 0 ? RichTextStyle.Primary : _textStyle;
    var isCurrentTab = activeTabName === name;
    var handleTabClick = function(ev) {
        ev.preventDefault();
        onSelectTab(name);
        ev.currentTarget.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center"
        });
    };
    var Button = isCurrentTab ? ActiveButton : InactiveButton;
    return /*#__PURE__*/ _jsx(Button, {
        "aria-selected": isCurrentTab,
        "aria-controls": "".concat(tabGroup, "-panel-").concat(position),
        id: "".concat(tabGroup, "-tab-").concat(position),
        onClick: handleTabClick,
        role: "tab",
        type: "button",
        textStyle: textStyle,
        children: /*#__PURE__*/ _jsx(InteractiveText, {
            inline: true,
            textColor: "current",
            children: name
        })
    }, name);
};
export { TabButton };
